<template>
    <div class="py-16 overflow-hidden lg:py-24">
        <div class="max-w-xl px-4 mx-auto sm:px-6 lg:max-w-screen-xl lg:px-8">
            <div class="pb-16 lg:text-center">
                <h3 class="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
                    And more!
                </h3>
            </div>
            <div class="lg:grid lg:grid-cols-3 lg:gap-8">
                <div>
                    <div class="flex items-center justify-center w-12 h-12 text-white rounded-md">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon">
                            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                            <polyline points="17 6 23 6 23 12"></polyline>
                        </svg>
                    </div>
                    <div class="mt-5">
                        <h5 class="text-lg font-medium leading-6 text-gray-900">
                            Keep your team in sync
                        </h5>
                        <p class="mt-2 text-base leading-6 text-gray-500">Feel more connected with your remote team. See and share your work.</p>
                    </div>
                </div>
                <div class="mt-10 lg:mt-0">
                    <div class="flex items-center justify-center w-12 h-12 text-white rounded-md">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="icon"
                        >
                            <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                            <polyline points="2 17 12 22 22 17"></polyline>
                            <polyline points="2 12 12 17 22 12"></polyline>
                        </svg>
                    </div>
                    <div class="mt-5">
                        <h5 class="text-lg font-medium leading-6 text-gray-900">Multiple Projects</h5>
                        <p class="mt-2 text-base leading-6 text-gray-500">Add projects for each of your teams! Keep teams focused and in the flow. No more clutter</p>
                    </div>
                </div>
                <div class="mt-10 lg:mt-0">
                    <div class="flex items-center justify-center w-12 h-12 text-white rounded-md">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="icon"
                        >
                            <path d="M22.08 9C19.81 1.41 16.54-.35 9 1.92S-.35 7.46 1.92 15 7.46 24.35 15 22.08 24.35 16.54 22.08 9z"></path>
                            <line x1="12.57" y1="5.99" x2="16.15" y2="16.39"></line>
                            <line x1="7.85" y1="7.61" x2="11.43" y2="18.01"></line>
                            <line x1="16.39" y1="7.85" x2="5.99" y2="11.43"></line>
                            <line x1="18.01" y1="12.57" x2="7.61" y2="16.15"></line>
                        </svg>
                    </div>
                    <div class="mt-5">
                        <h5 class="text-lg font-medium leading-6 text-gray-900"><span class="text-gray-400">(Coming soon)</span> Slack Integrations</h5>
                        <p class="mt-2 text-base leading-6 text-gray-500">
                            Easily add Flowist to your slack channels. Know when things get done, get status updates, and team announcements directly where you are!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app-more',
};
</script>
<style></style>
